import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { UrgentManufacturingOrder } from '../urgent-manufacturing-order';
import { ManufacturingOrderBuilder } from './manufacturing-order.builder';
import { UserBuilder } from './user.builder';

export class UrgentManufacturingOrderBuilder {
  static fromJson(json) {
    return json
      ? new UrgentManufacturingOrder(
          json.hash,
          parseNumber(json.date),
          ManufacturingOrderBuilder.fromJson(json.manufacturingOrder),
          UserBuilder.fromJson(json.user)
        )
      : null;
  }

  static fromList(list) {
    return isArray(list)
      ? list.map(UrgentManufacturingOrderBuilder.fromJson)
      : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/urgent-manufacturing-order.builder.ts